module.exports = __webpack_public_path__ + "img/left_slide.66d65c42.svg";